<template>
  <div class="about">
    <md-progress-bar v-show="currentAccountLoading" class="md-accent md-layout-item md-size-100" md-mode="indeterminate"></md-progress-bar>
    <account v-if="!currentAccountLoading" v-on:new-transaction="postTransaction" :account="currentAccount" :transactions="currentAccountTransactions" ></account>
  </div>
</template>
<script>
// @ is an alias to /src
import Account from '@/components/Account.vue'
import { db } from '@/db'
import { mapGetters } from 'vuex';
export default {
  name: 'home',
  components: {
    Account
  },
  props:{
    id:String
  },
  computed:{
    ...mapGetters(['currentBankBalance', 'currentAccount', 'currentAccountTransactions', 'currentAccountLoading']),
  },
  methods:{
    postTransaction(transaction){
      transaction.bankBalance = transaction.amount + this.currentBankBalance;
      db.ref('bankTransactions').push(transaction);
      let update = {
        balance: transaction.accountBalance,
      };
      if(transaction.amount < 0){
        update.withdrawls = this.currentAccount.withdrawls + 1;
      }
      else{
        update.deposits = this.currentAccount.deposits + 1
      }
      db.ref(`bankAccounts/${this.id}`).update(update);
    }
  },
  mounted(){
    this.$store.dispatch('bindCurrentAccount', {ref: db.ref(`bankAccounts/${this.id}`)});
    this.$store.dispatch('bindCurrentTransactions', {ref: db.ref(`bankTransactions`).orderByChild('ID').equalTo(this.id)});
  }
}
</script>